{{ (amount || 0) | currency: currency:'symbol': precision }}